import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppClientResourcesModule, ApplicationClientCommonModule, CommonUIComponentsModule, MasterDetailModule,  PagedContentModule,  ServiceResponseModule } from '@sdbn/common';
import { ColorPickerModule } from '@sdbn/tmc-common';
import { InputIntegerModule } from '@sdbn/tmc-common';
import { TransportOptionsAdministrationComponent } from './component/admin-component/transport-options-administration.component';
import { TransportOptionsStructureEditorComponent } from './component/structure-editor/transport-options-strcuture-editor.component';

import { DictionaryModule } from '@sdbn/common';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { ConstraintOptionAssignmentEditorComponent } from './component/constraint-option-assignment-editor/constraint-option-assignment-editor.component';
import { TimePriorityListComponent } from './component/time-priority-list/time-priority-list.component';
import { TransportOptionConstraintsEditorComponent } from './component/transport-option-constraints/transport-option-constraints-editor.component';
import { TransportOptionEditorControlComponent } from './component/transport-option-editor-control/transport-option-editor-control.component';
import { TransportOptionEditorLabelingComponent } from './component/transport-option-editor-labeling/transport-option-editor-labeling.component';
import { TransportOptionEditorLoadingComponent } from './component/transport-option-editor-loading/transport-option-editor-loading.component';
import { TransportOptionEditorParameterComponent } from './component/transport-option-editor-parameter/transport-option-editor-parameter.component';
import { TransportOptionEditorValidationComponent } from './component/transport-option-editor-validation/transport-option-editor-validation.component';
import { TransportOptionEditorFilesComponent } from './component/transport-option-editor-files/transport-option-editor-files.component';
import { AppClientComponentModule } from '@sdbn/common';
import { TransportOptionEditorComponent } from './component/transport-option-editor/transport-option-editor.component';

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';

import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TransportOptionEditorLimitsComponent } from './component/transport-option-editor-limits/transport-option-editor-limits.component';
import { TransportOptionEditorLimitsScheduleComponent } from './component/transport-option-editor-limits/transport-option-editor-limits-schedule/transport-option-editor-limits-schedule.component';
import { TransportOptionEditorLimitsExceptionScheduleComponent } from './component/transport-option-editor-limits/transport-option-editor-limits-exception-schedule/transport-option-editor-limits-exception-schedule.component';
import { ConditionsComponent } from './component/conditions/conditions.component';
import { ConditionEditorComponent } from './component/conditions/condition-editor/condition-editor.component';
import { ConditionAssignmentsComponent } from './component/condition-assignments/condition-assignments.component';

@NgModule({
  declarations: [
    TransportOptionsAdministrationComponent,
    TransportOptionsStructureEditorComponent,
    TransportOptionEditorComponent,
    TimePriorityListComponent,
    TransportOptionConstraintsEditorComponent,
    ConstraintOptionAssignmentEditorComponent,
    TransportOptionEditorControlComponent,
    TransportOptionEditorLabelingComponent,
    TransportOptionEditorLoadingComponent,
    TransportOptionEditorParameterComponent,
    TransportOptionEditorValidationComponent,
    TransportOptionEditorFilesComponent,
    TransportOptionEditorLimitsComponent,
    TransportOptionEditorLimitsScheduleComponent,
    TransportOptionEditorLimitsExceptionScheduleComponent,
    ConditionsComponent,
    ConditionEditorComponent,
    ConditionAssignmentsComponent
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    CommonLayoutModule,
    DictionaryModule,
    PagedContentModule,

    ReactiveFormsModule,
    FormsModule,
    InputIntegerModule,
    ColorPickerModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonTranslationModule,
    AppClientComponentModule,
    AppClientResourcesModule,
    MasterDetailModule,

    MatFormFieldModule,
    MatSelectModule,
    DragDropModule,
    MatTabsModule,
    MatInputModule,
    MatSlideToggleModule
  ],
  exports: [
  ]
})
export class TransportOptionsAdministrationModule { }
